
import { Button } from "@/components/ui/button";
import { Loader, Save } from "lucide-react";

interface ProductFormActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
}

const ProductFormActions = ({
  onCancel,
  isSubmitting,
  isSubmitDisabled,
}: ProductFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2 w-full">
      <Button
        variant="outline"
        onClick={onCancel}
        type="button"
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button 
        disabled={isSubmitDisabled || isSubmitting}
        className="bg-blue-500 hover:bg-blue-600"
        type="submit"
      >
        {isSubmitting ? (
          <>
            <Loader className="mr-2 h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Save Product
          </>
        )}
      </Button>
    </div>
  );
};

export default ProductFormActions;
